import React, { useEffect, useContext } from 'react';
import { store } from '../reducer';
import Form from './Form';
import { isMobile } from 'react-device-detect';
import RulesProvider from './RulesProvider';
import ListCategories from './ListCategories';
import AddOrEdit from './AddOrEdit';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
}));

const Rules = () => {
  useTitle('مدیریت عملکرد ها')
  const classes = useStyles();
  const { dispatch, showMessage, showError } = useContext(store);
  const { path, isExact } = useRouteMatch();

  useEffect(() => {
    isExact &&
      dispatch({
        type: 'CHANGE_TITLE_SUBTITLE',
        payload: {
          title: 'مدیریت عملکردها',
          subtitle:
            'نقشی که قصد دارید به آن عملکردی اضافه،حذف یا ویرایش کنید را انتخاب کنید',
        },
      });
  }, [isExact]);

  return (
    <RulesProvider showError={showError} showMessage={showMessage}>
      <div className={classes.root}>
        <Switch>
          <Route exact path={`${path}`}>
            <ListCategories />
          </Route>
          <Route path={`${path}/:category`}>
            <AddOrEdit />
          </Route>
        </Switch>
      </div>
    </RulesProvider>
  );
};

export default React.memo(Rules);
